module.exports = {
    title: "Institute Chain",
    crud: {
        create: "Create Institute Chain",
        edit: "Edit Institute Chain",
        view: "View Institute Chain",
    },
    table: {
        code: "Code",
        startDate: "Start Date",
        endDate: "End Date",
        type: 'Type',
        name: 'User Name',
    },
    detail: {
        title: 'City View',
        currencyName: 'currencyName',
        users: 'Institute Chain Users'
    },
    form: {
        company: "Company Name",
        city: "City",
        country: "Country",
        state: "State",
        contactNo: "Contact No",
        companyEmail: "Company Email",
        website: "Website",
        firstName: "Name",
        lastName: "Last Name",
        email: "Email",
        mobileNo: "Mobile No",
        address1:"Address"
    },
    placeholder: {
        country: "Select Country",
        state: "Select State"

    },
    validation: {
        required: {
            mobileNumber:"Please enter mobile number.",
            bodyName:"Please enter body name.",
            description:"Please enter description.",
            address:"Please enter address.",
            website:"Please enter website.",
            email:"Please enter email.",
        },
        email: {
            email: 'Please enter valid email',
            companyEmail:"Please enter valid company email",
        },
    },
}
